module.exports = __webpack_public_path__ + "logo_azure.457ec.png";